// import store from '../../store';
import axios from 'axios';
import * as ShipConstants from '../../Global/Constants';
import { decryptAES, isSet } from '../../Utils/CommonFunctions';
import { getGuestUserKey, clearGuestUserKey } from '../../Utils/UserFunctions';
import { IsEncrypted } from '../../envConfig';
// import {failMessage} from '../../store/actions/CommonActions';


// import {removeAuthentication} from '../../Store/actions/Auth';

const configAxios = axios.create({
    baseURL:  ShipConstants.API_URL,
});

const requestHandler = request => {
    // Auth Token  
    const accessToken = localStorage.getItem('access_token');
    const isPublicPagesRequest = request.url && request.url.indexOf('public-pages/') !== -1;
    let customHeaders = {};
    if(IsEncrypted===true){
        customHeaders = {
            'X-Encrypted-Data':'dHJ1ZQ=='
        }
    }
    let guestUserHeader = {};
    if(isPublicPagesRequest){
        const guestKey = getGuestUserKey() ;
        guestUserHeader = {
            'xGuestKey': 'Bearer '+ guestKey,
            'xAutherized': 'true'
        }
    }else{
        request.params = {
            ...request.params,
            access_token: accessToken
        }
    }
    // console.log('request.headers',request.headers);
    request.headers  = {
        ...customHeaders,
		...request.headers,
        ...guestUserHeader
		// 'X-Encrypted-Data':btoa(IsEncrypted),
	}
    // const data = decryptAES();
	// console.log('decryptAES',data);
    // console.log('request',request);
    return request;
};

const responseHandler = response => {
    const {config} = response;
    let isEnc = false;
    try{
        isEnc = (isSet(config.headers['X-Encrypted-Data'],null)!==null)?true:false;
    }catch(e){

    }

    
    if (response.status === 401) {
        // window.location = '/login';
    }
    // console.log('response',isEnc);
    try{
		let returnResponse = {...response};
        // console.log('returnResponse',returnResponse);
		if(isSet(response.status,response.statusCode)===200){
			const resData = response.data;
            // if(resData.code==400 && resData.message===ShipConstants.INACTIVE_USER_MSG){
            if(resData.code==401 && ShipConstants.INACTIVE_USER_MSG.some(msg =>
                resData.message.toLowerCase().includes(msg.toLowerCase())
            )){
				// const {dispatch} = store;
                // dispatch(failMessage(resData.message));
                localStorage.setItem('LoggedOutMsg',resData.message);
				localStorage.removeItem('access_token');
				localStorage.removeItem('refresh_token');
                // document.body.style.display = 'none';
                const el = document.querySelector('.viewport');
                const el1 = document.querySelector('.main-panel');
                if (el1) {
                    el1.style.display = 'none';
                }else if (el) {
                    el.style.display = 'none';
                }
                document.location.href ='/login';
				localStorage.removeItem('user');
				localStorage.removeItem('moduleId');
                clearGuestUserKey();
                // document.location.href ='/login';
				
                // dispatch(failMessage(resData.message));
				
			}
			returnResponse ={
				...returnResponse,
				data:{
					...resData,
					data:isEnc===true?decryptAES(resData.data):resData.data,
				}
			}
			// console.log('returnRes',returnResponse.data);
		}
        return returnResponse;
	}catch(e){
		return null;
	}
    // console.log('responseHandler',response);
    // return response;
};

//Request Error Handler
const requestErrorHandler = error => {
    return Promise.reject(error);
};

//Response Error Handler
const responseErrorHandler = error => {
    // handle the response error
    // console.log('reserror',error);
    /*1021 - Issue fix --start */
    try{
        if(error.response && error.response.data.error==="invalid_token"){
            // const {dispatch} = store;
            // console.log('invalid token');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
            localStorage.removeItem('moduleId');
            clearGuestUserKey();
            // dispatch(failMessage(error.response.data.message));
            document.location.href ='/login';
        }
        else if(error.response && (error.response.status===403)){
            console.log(error.response);
            // const {dispatch} = store;
            // dispatch(failMessage(error.response.data.message));
            //For checking session is expired or not and redirect to login page.
            
        }
    }catch(e){

    }
    // try{
    //     if (error.response.data.error === "invalid_token") {
    //         const { dispatch } = store;
    //         // dispatch(removeAuthentication());
    //     } else if (error.response && (error.response.status === 403)) {
    //         console.log('res1error', error,error.response);
    //         //For checking session is expired or not and redirect to login page.
    //     }
    // }catch(e){

    // }
    if(error.response !== undefined){
        return Promise.reject(error.response);
    }else{
        return Promise.reject(error);
    }
        /*1021 - Issue fix --end */

};


configAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => requestErrorHandler(error)
);

configAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => responseErrorHandler(error)
);

export default configAxios;